import { render, staticRenderFns } from "./OfferTermForm.vue?vue&type=template&id=e8dfbd16&"
import script from "./OfferTermForm.vue?vue&type=script&lang=js&"
export * from "./OfferTermForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports